import React from 'react';
import { NavLink } from 'reactstrap';
import classnames from 'classnames';
import { TabNavigationItem } from '../models/tabNavigationItem';
import { TabDropdownItemComponent } from './tabDropdownItem/tabDropdownItem';
import { Icon, TsrPopover, TsrSvgIcon } from 'tacho-ui';
import './styles.scss';

interface TabDropdownProps {
    activeTabIndex: number;
    isOpen: boolean;
    isActive: boolean;
    isVisible: boolean;
    items: Array<TabNavigationItem>;
    upperCaseTabs?: boolean;
    dropdownTabs?: Array<TabNavigationItem>;
    toggle: () => void;
    onTabItemClick: (tabIndex: number) => void;
    onTabItemClose: (tabIndex: number) => void;
    onTabItemReset: (tabIndex: number) => void;
}

export class TabDropdownComponent extends React.Component<TabDropdownProps> {
    public render(): JSX.Element {
        if (!this.props.isVisible) {
            return <></>;
        }
        return (
            <li
                className={classnames(
                    'nav-item dropdown',
                    { show: this.props.isOpen },
                    { activeTab: this.props.isActive },
                    { inactiveTab: !this.props.isActive },
                )}
            >
                <TsrPopover
                    visible={this.props.isOpen}
                    onClickOutside={() => this.props.toggle()}
                    contentClassName="tabDropdownMenu dropdownTabsBackground"
                    content={this.props.items.map(tabItem => (
                        <TabDropdownItemComponent
                            key={`tabDropdownItem${tabItem.index}${tabItem.label}`}
                            isActive={this.props.activeTabIndex === tabItem.index}
                            label={tabItem.label}
                            isUpperCase={this.props.upperCaseTabs}
                            isClosable={tabItem.isCloseable}
                            isResetable={tabItem.isResetable}
                            onResetDefault={() => this.props.onTabItemReset(tabItem.index)}
                            onClick={() => {
                                this.props.onTabItemClick(tabItem.index);
                                this.props.toggle();
                            }}
                            onClose={() => this.props.onTabItemClose(tabItem.index)}
                        />
                    ))}
                >
                    <NavLink onClick={() => this.props.toggle()}>
                        <TsrSvgIcon
                            icon={Icon.DotsCircle}
                            size="large"
                            className={
                                this.props.isOpen ||
                                this.props.dropdownTabs?.find(item => item.index === this.props.activeTabIndex)
                                    ? `color-accent`
                                    : 'color-info'
                            }
                            pointer
                        />
                    </NavLink>
                </TsrPopover>
            </li>
        );
    }
}
